import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import confirmMailImg from '@/assets/confirm-mail.png';

interface EmailConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  isDarkMode?: boolean;
}

export const EmailConfirmationModal: React.FC<EmailConfirmationModalProps> = ({
  isOpen,
  onClose,
  email,
  isDarkMode = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/50"
      tabIndex={-1}
      style={{ zIndex: 99999 }}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <div
        className={`relative w-full max-w-md mx-4 rounded-2xl shadow-xl overflow-hidden border bg-white`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="email-confirmation-title"
        aria-describedby="email-confirmation-description"
      >

        {/* Content */}
        <div className="p-6">
          <div className="w-full flex justify-center">
            <img
              src={confirmMailImg}
              alt="Email Confirmation"
              className="w-40 h-40 object-contain select-none"
              draggable={false}
            />
          </div>

          <div className="mt-4 text-center">
            <h3
              id="email-confirmation-title"
              className={`text-xl font-semibold text-emerald-600`}
            >
              Verify your email
            </h3>
            <p
              id="email-confirmation-description"
              className={`mt-2 text-sm text-neutral-600`}
            >
              An email confirmation has been sent to <span className="font-medium">{email}</span>. Please check your inbox and verify your email to activate your account.
            </p>
          </div>

          <div className="mt-6 mx-auto flex justify-center">
            <button
              onClick={onClose}
              className="w-[200px] py-2.5 rounded-full text-white bg-emerald-600 hover:bg-emerald-700 transition-colors"
            >
              Okay, got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmationModal;
